(() => {
  if (customElements.get('bedz-payoff')) return;
  customElements.define('bedz-payoff', class extends HTMLElement {
    connectedCallback() {
      const root = this.closest('[data-product]') || this.parentElement;
      const price = root.querySelector('[data-product-price]');
      const update = () => {
        const text = price ? price.textContent.trim() : '';
        const amount = text ? Number(text.replace(/[^0-9.]/g, '')) * 100 : Number(this.dataset.price);
        this.hidden = !Number.isFinite(amount) || amount <= 0;
        if (this.hidden) return;
        const money = new Intl.NumberFormat('en-US', {style: 'currency', currency: 'USD'});
        this.querySelector('[data-payoff-six]').textContent = money.format(Math.ceil(Math.round(amount) / 6) / 100) + '/mo';
        this.querySelector('[data-payoff-twelve]').textContent = money.format(Math.ceil(Math.round(amount) / 12) / 100) + '/mo';
      };
      update();
      if (price) { this.observer = new MutationObserver(update); this.observer.observe(price, {childList:true, subtree:true, characterData:true}); }
    }
    disconnectedCallback() { if (this.observer) this.observer.disconnect(); }
  });
})();
